// extracted by mini-css-extract-plugin
export default {"rank":"treadwell-icon__rank___-mQ4L"};